module.exports = __webpack_public_path__ + "static/manage-business-ac77ea6e6f14833eec63a064778cbaf8.png";